<script setup lang="ts">
import SignupFormTitle from '@/components/FormSection/SignupFormTitle.vue'
import SignupFormIntroduction from '@/components/FormSection/SignupFormIntroduction.vue'
import SignupForm from '@/components/FormSection/SignupForm.vue'
import SignUpImage from '@/components/svg/SignUpImage.vue'

const emit = defineEmits(['submit'])
</script>

<template>
  <div class="row">
    <div class="col text-center" data-testid="signup-main-image">
      <sign-up-image class="my-5" />
    </div>
  </div>

  <div class="row">
    <div
      class="col col-sm-12 col-lg-10 col-xl-6 m-auto text-center"
      data-testid="signup-title-area"
    >
      <signup-form-title />
      <signup-form-introduction />
    </div>
  </div>

  <div class="row mb-4">
    <div class="col col-sm-12 col-lg-10 col-xl-6 m-auto text-center">
      <signup-form @submit="emit('submit')" />
    </div>
  </div>
</template>
